/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {AbstractControl, FormArray, FormGroup} from '@angular/forms';

export function Unique(formArrayControlName: string, controlName: string) {
  return (formGroup: FormGroup | FormArray) => {
    const formArray: FormArray = formGroup.controls[formArrayControlName];

    if (formArray) {
      formArray.controls.forEach((fg: FormGroup, i: number) => {
        const control: AbstractControl = fg.controls[controlName];

        if (control && control.value && '' !== control.value.toString().trim()) {
          const nf = formArray.controls.filter((it: AbstractControl, index: number) => i !== index && it.value[controlName] === control.value).length;
          control.setErrors(0 < nf ? {unique: true} : null);
        }
      });
    }
  };
}
